import { render, staticRenderFns } from "./DocumentExtraFieldsForm.vue?vue&type=template&id=08bf2d09&scoped=true"
import script from "./DocumentExtraFieldsForm.vue?vue&type=script&lang=js"
export * from "./DocumentExtraFieldsForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentExtraFieldsForm.vue?vue&type=style&index=0&id=08bf2d09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf2d09",
  null
  
)

export default component.exports